import { Component, ComponentInterface, Event, EventEmitter, Listen, Prop, Host, h } from '@stencil/core';

import { now } from '../../../utils/helpers';

@Component({
  tag: 'lar-backdrop',
  styleUrl: 'backdrop.scss',
  shadow: true
})
export class Backdrop implements ComponentInterface {

  private lastClick = -10000;

  /**
   * If `true`, the backdrop will be visible. Defaults to `true`.
   */
  @Prop() visible = true;

  /**
   * If `true`, the backdrop will can be clicked and will emit the `larbackdroptap` event. Defaults to `true`.
   */
  @Prop() tappable = true;

  /**
   * If `true`, the backdrop will stop propagation on tap. Defaults to `true`.
   */
  @Prop() stopPropagation = true;

  /**
   * Emitted when the backdrop is tapped.
   */
  @Event() larbackdroptap!: EventEmitter<void>;

  @Listen('touchstart', { passive: false, capture: true })
  protected onTouchStart(ev: TouchEvent) {
    this.lastClick = now(ev);
    this.emitTap(ev);
  }

  @Listen('click', { passive: false, capture: true })
  // @Listen('mousedown', { passive: false, capture: true })
  protected onMouseDown(ev: TouchEvent) {
    if (this.lastClick < now(ev) - 2500) {
      this.emitTap(ev);
    }
  }

  private emitTap(ev: Event) {
    if (this.stopPropagation) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    if (this.tappable) {
      this.larbackdroptap.emit();
    }
  }
  render() {
    return (
      <Host tabindex="-1" class={{ 'lar-backdrop-hide': !this.visible, 'lar-backdrop-no-tappable': !this.tappable }} />
    );
  }

}
